export default __webpack_public_path__ + "static/media/MODALgarbanzo_ZH.9a3a9c9c.jpg";